var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#3773A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32H34V25.0314C34 21.1481 30.866 18 27 18C23.134 18 20 21.1481 20 25.0314V32ZM27 16C31.9706 16 36 20.0435 36 25.0314V34H18V25.0314C18 20.0435 22.0294 16 27 16ZM24.5 35H29.5C29.5 36.3807 28.3807 37.5 27 37.5C25.6193 37.5 24.5 36.3807 24.5 35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.6f895afc0d8a930baf9b43d33b9668f2.svg";
export { ForwardRef as ReactComponent };